module.exports = __webpack_public_path__ + "img/pic-07.a3905a70.png";